// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { SUBSCRIPTION_GROUPS_KEY } from "./constants";
import type { SubscriptionGroupPayload } from "./types";

export const getWhatsAppSubscriptionGroups = reactQueryFetcherAdapter(
  SUBSCRIPTION_GROUPS_KEY,
  async (signal, appGroupId: string, limit?: number): Promise<SubscriptionGroupPayload> => {
    return fetch(
      `/engagement/${appGroupId}/whats_app_subscription_groups`,
      "GET",
      { query: null, limit },
      {
        signal,
      }
    );
  }
);
